import ScheduleDetail from './ScheduleDetail';

export default ScheduleDetail;
